import { user } from "@/stores/session";

const MAX_SERVERS = 30;
const MAX_COMMANDS = 100;
const histories = new Map<string, string[]>();
let accountId: string | null = null;

user.subscribe((account) => {
  const nextId = account?.id ?? null;
  if (nextId !== accountId) {
    histories.clear();
    accountId = nextId;
  }
});

export function commandHistory(serverId: string | null): readonly string[] {
  return serverId && accountId ? (histories.get(serverId) ?? []) : [];
}

export function rememberCommand(serverId: string | null, command: string): void {
  if (!serverId || !accountId) {
    return;
  }
  const history = histories.get(serverId) ?? [];
  if (history.at(-1) !== command) {
    history.push(command);
    if (history.length > MAX_COMMANDS) {
      history.shift();
    }
  }
  histories.delete(serverId);
  histories.set(serverId, history);
  if (histories.size > MAX_SERVERS) {
    const oldest = histories.keys().next().value;
    if (oldest) {
      histories.delete(oldest);
    }
  }
}
